export default __webpack_public_path__ + "static/media/carousel-isp-mdu-04.3ce36271.png";